import { User } from 'types/User'
import { apiv2Client } from './apiv2'

export const getUser = async () => {
  const dataApiRealGetUser: any = await apiv2Client.get<User>('/admin/me', {})
  return dataApiRealGetUser
}
